import iziToast, { IziToastSettings } from 'izitoast';
import PolygonsLoader from '../classes/loaders/PolygonsLoader';
import RoadNetLoader from '../classes/loaders/RoadNetLoader';
import ForbiddenAreasLoader from "../classes/loaders/ForbiddenAreasLoader";

const polygonsLoader = new PolygonsLoader();
const forbiddenAreasLoader = new ForbiddenAreasLoader();
const roadNetLoader = new RoadNetLoader();

export default class PublisherStore {
  public countWaitForPublish: number = 0;
  public publishing: boolean = false;
  private _roadNetCount: number = roadNetLoader.lineStringStoresCount;
  private _polygonsCount: number = polygonsLoader.polygonStoresCount;
  private _forbiddenCount:number = forbiddenAreasLoader.forbiddenStoresCount;

  constructor() {
    this.countWaitForPublish = this._polygonsCount + this._roadNetCount + this._forbiddenCount;
    polygonsLoader.on('polygons_updated', () => {
      this._polygonsCount = polygonsLoader.polygonStoresCount;
      this.countWaitForPublish = this._polygonsCount + this._forbiddenCount + this._roadNetCount;
    });
    forbiddenAreasLoader.on('updated',()=>{
      this._forbiddenCount = forbiddenAreasLoader.forbiddenStoresCount;
      this.countWaitForPublish = this._polygonsCount + this._forbiddenCount + this._roadNetCount;
    })
    roadNetLoader.on('local-updated', () => {
      this._roadNetCount = roadNetLoader.lineStringStoresCount;
      this.countWaitForPublish = this._polygonsCount + this._forbiddenCount + this._roadNetCount;
    });
  }

  public publish() {
    this.publishing = true;
    (async () => {
      await polygonsLoader.publish();
      await forbiddenAreasLoader.publish();
      await roadNetLoader.publish();
    })().then(() => {
      this.publishing = false;
    }).catch((e: Error) => {
      iziToast.error({ title: e.message } as IziToastSettings);
      this.publishing = false;
    });
  }

  public reset() {
    polygonsLoader.reset();
    forbiddenAreasLoader.reset();
    roadNetLoader.reset();
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/stores/PublisherStore.ts